
  import { mapState } from 'vuex'
  export default {
    name: 'Theme2MissionVipPrivilegeTermAndConditionDialog',
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState({
        vipSystem: state => state.activities['vip-system'].vipSystem
      }),
      modal: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    }
  }
